import { call, put } from "redux-saga/effects";
import { startSubmit, stopSubmit } from "redux-form";
import { Auth } from "aws-amplify";

import * as MiniMessageBox from "../../../../MiniMessageBox";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function* authnzCognitoConfirmation(arg0: { email: string; confirmation_code: string }): Generator<any, any, any> {
  const { email, confirmation_code } = arg0;
  return yield Auth.confirmSignUp(email, confirmation_code);
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function* authnzConfirmRegistrationWorker(action: any): Generator<any, any, any> {
  const form = "ConfirmationForm";

  const { payload, navigate } = action;

  try {
    yield put(startSubmit(form));

    yield call(authnzCognitoConfirmation, payload.data);
    yield put(stopSubmit(form));
    navigate("/");
  } catch (error) {
    yield put(stopSubmit(form));

    // @ts-ignore
    if (error instanceof Error || error?.message) {
      // @ts-ignore
      yield put(MiniMessageBox.showMiniBoxMessage({ show: true, type: "error", message: error?.message }));
    }
  }
}
